import api, { baseURL } from "../../../../utils/api"

export const getAllClients = (page, limit, searchQuery, fromDate = null, toDate = null) =>{
	let url = `${baseURL}/user/allclients?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}`;
	if (fromDate) {
		url += `&fromDate=${fromDate}`;
	}
	if (toDate) {
		url += `&toDate=${toDate}`;
	}
	return api.get(url);
}

export const deleteClient = (clientId) =>{
	return api.delete(`${baseURL}/user/deleteuser?id=${clientId}`);
}

export const getClientVendorList = (id) => {
	return api.get(`${baseURL}/user/allclients/${id}`);
}
export const addClientManually = (formData) => {
	return api.post(`${baseURL}/auth/addClientOrVendorManuallyFromCms`, formData);
  };

export const clientVendorConnectionHeaders = [
	"Sr No.",
	"Vendor"
]